const removeWhiteBackground = (dataUrl, options = {}) => {
  if (!dataUrl || typeof document === 'undefined') {
    return Promise.resolve(dataUrl);
  }

  const { whiteThreshold = 245, alphaThreshold = 10 } = options;

  return new Promise((resolve) => {
    const image = new Image();

    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        const context = canvas.getContext('2d');
        if (!context) {
          resolve(dataUrl);
          return;
        }

        context.drawImage(image, 0, 0);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const pixels = imageData.data;

        for (let index = 0; index < pixels.length; index += 4) {
          const red = pixels[index];
          const green = pixels[index + 1];
          const blue = pixels[index + 2];
          const alpha = pixels[index + 3];

          if (
            alpha > alphaThreshold &&
            red >= whiteThreshold &&
            green >= whiteThreshold &&
            blue >= whiteThreshold
          ) {
            pixels[index + 3] = 0;
          }
        }

        context.putImageData(imageData, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch (error) {
        resolve(dataUrl);
      }
    };

    image.onerror = () => resolve(dataUrl);
    image.src = dataUrl;
  });
};

export async function loadImageBase64(url, options = {}) {
  if (!url) return null;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Cannot fetch image');

    const blob = await response.blob();
    const reader = new FileReader();

    const dataUrl = await new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    if (options.transparentWhite) {
      return await removeWhiteBackground(dataUrl, options);
    }

    return dataUrl;
  } catch (error) {
    console.error('Error loading image:', url, error);
    return null;
  }
}
